import { ResourceItem, ItemDiff } from "../ResourceItem";
import { ZastosowanieCategory } from "./ZastosowanieCategory";
import {
  apiField,
  itemApiField,
  constructFromApiData,
  getApiPostData,
} from "../ResourceItemMetadata";
import _ from "lodash";

export class Zastosowanie extends ResourceItem {
  @itemApiField(ZastosowanieCategory)
  category!: ZastosowanieCategory;

  @apiField()
  properties!: { [key: string]: any };

  constructor(data?: any) {
    super(data);

    if (data) {
      constructFromApiData(this, data);
    }
  }

  getPostData() {
    return {
      id: this.id,
      ...getApiPostData(this),
    };
  }

  getDiff(other: this) {
    const result: ItemDiff = {};

    this.category.attributes.forEach((atr) => {
      if (!_.isEqual(this.properties[atr.key], other.properties[atr.key]))
        result[atr.key] = true;
    });
    return result;
  }
}
